import { domain } from 'modules/data';
import { InfoIconGreen, InfoIconOrange, InfoIconRed } from 'modules/sprites';
import { memo } from 'react';

import { StyledInfoIconGray } from './InfoIcon.styles';
import { InfoIconProps } from './InfoIcon.types';

export const InfoIcon = memo<InfoIconProps>((props) => {
    const { status, noPaymentDetails } = props;

    switch (status) {
        case domain.PaymentDetailsPaymentStatus.PaidPreviously:
            return <InfoIconGreen />;

        case domain.PaymentDetailsPaymentStatus.NeverPaid:
            return <InfoIconOrange />;

        case domain.PaymentDetailsPaymentStatus.PaymentDetailsChanged:
            return <InfoIconRed />;

        default:
            return <StyledInfoIconGray $disabled={noPaymentDetails} />;
    }
});

InfoIcon.displayName = 'InfoIcon';
